
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-dark-800 text-white border-t border-dark-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-10 sm:mb-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <img 
              src="https://static.readdy.ai/image/607c853629dc4b228801d270367dd43a/15c46b4804cbc70ab5f2207b2f29e22b.png" 
              alt="Logo" 
              className="h-10 sm:h-12 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Especialista em soluções inovadoras em inteligência artificial e automação
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-white mb-4">Serviços</h3>
            <ul className="space-y-3">
              <li>
                <a href="https://neuroagentsglobal.com/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-400 transition-colors text-sm cursor-pointer">
                  Neuro Agents AI
                </a>
              </li>
              <li>
                <a href="https://lp.aros.com.br?fpr=rafael-figueiredo-silva43" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-400 transition-colors text-sm cursor-pointer">
                  Agentes de IA
                </a>
              </li>
              <li>
                <a href="https://readdy.ai/?via=rafael" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-400 transition-colors text-sm cursor-pointer">
                  Criação de Sites
                </a>
              </li>
              <li>
                <button onClick={() => scrollToSection('contato')} className="text-gray-400 hover:text-red-400 transition-colors text-sm cursor-pointer">
                  Consultoria
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-white mb-4">Conecte-se</h3>
            <ul className="space-y-3">
              <li>
                <a href="https://instagram.com/neuroagentsglobal" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-400 transition-colors text-sm flex items-center cursor-pointer">
                  <i className="ri-instagram-line mr-2"></i>
                  @neuroagentsglobal
                </a>
              </li>
              <li>
                <a href="https://wa.me/5541992584018" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-green-400 transition-colors text-sm flex items-center cursor-pointer">
                  <i className="ri-whatsapp-line mr-2"></i>
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-white mb-4">Contato Rápido</h3>
            <div className="space-y-3">
              <a href="https://wa.me/5541992584018" target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-400 hover:text-green-400 transition-colors text-sm cursor-pointer">
                <i className="ri-whatsapp-line mr-2 text-green-500"></i>
                (41) 99258-4018
              </a>
              <a href="https://instagram.com/neuroagentsglobal" target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-400 hover:text-pink-400 transition-colors text-sm cursor-pointer">
                <i className="ri-instagram-line mr-2 text-pink-500"></i>
                @neuroagentsglobal
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-dark-600 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm text-center sm:text-left">
              © 2025 Rafael Figueiredo. Todos os direitos reservados
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-red-400 text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
